import useSWR from 'swr'
import { getQuickAddOns } from '../core/api-methods'
import { QuickAddOnAddonLevel, QuickAddOnUiAsset } from '../types/quickAddOnV2'

export type QuickAddOnPreviewItem = {
  id: string
  addonLevel: QuickAddOnAddonLevel
  uiAsset: QuickAddOnUiAsset
  status: boolean
  metadata?: any
}

const getQuickAddOnPreviewKey = (addonLevel: QuickAddOnAddonLevel) => ['quick-add-on-cart-preview', addonLevel] as const

const fetchQuickAddOnPreviewList = async (addonLevel: QuickAddOnAddonLevel): Promise<QuickAddOnPreviewItem[]> => {
  try {
    const response: any = await getQuickAddOns(addonLevel)
    const items = response?.data ?? []
    return items.map((item: any) => ({
      id: item.addon_id,
      addonLevel: item.addon_level,
      uiAsset: item.ui_asset,
      status: Boolean(item.is_active),
      metadata: item.metadata ?? {}
    }))
  } catch {
    return []
  }
}

export const useQuickAddOnPreviewTable = (): QuickAddOnPreviewItem[] => {
  const { data: itemLevelAddOns } = useSWR(getQuickAddOnPreviewKey(QuickAddOnAddonLevel.ITEM), () =>
    fetchQuickAddOnPreviewList(QuickAddOnAddonLevel.ITEM)
  )
  const { data: cartLevelAddOns } = useSWR(getQuickAddOnPreviewKey(QuickAddOnAddonLevel.CART), () =>
    fetchQuickAddOnPreviewList(QuickAddOnAddonLevel.CART)
  )

  return [...(itemLevelAddOns ?? []), ...(cartLevelAddOns ?? [])]
}
